<template>
  <ResponsiveModal
    :variant="variant"
    :title="title"
    :description="description"
    :withClear="maxSmall"
    :confirmLabel="$t('components.buttons.apply')"
    :showCancel="!maxSmall"
    :disableConfirm="!dateRef?.isDirty"
    @update:open="(open) => open && dateRef?.reset()"
    @confirm="dateRef?.submit()"
    @clear="$emit('update', null)"
  >
    <slot />
    <template #content>
      <div v-if="!maxSmall" class="h-5" />
      <Date
        ref="dateRef"
        :initialState="initialState"
        :minDate="minDate"
        :maxDate="maxDate"
        class="w-full py-5 px-4 bg-primary"
        @submit="$emit('update', $event)"
      />
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ref } from "vue";
import { Date } from "@/SharedComponents/Modals/Content";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["update"]);

const dateRef = ref(null);

defineProps({
  variant: { type: String, required: false },
  title: { type: String, required: false },
  description: { type: String, required: false },
  initialState: { type: [String, Date, Number], default: null },
  minDate: { type: Date, default: null },
  maxDate: { type: Date, default: null },
});
</script>
